module.exports = __webpack_public_path__ + "img/link-01.6453b84d.svg";